// Taken from https://github.com/gatsbyjs/gatsby/tree/master/examples/using-redux
import wrapWithProvider from './wrap-with-provider';
export const wrapRootElement = wrapWithProvider;
